import NoticeDetailContainer from './NoticeDetailContainer';
export default NoticeDetailContainer;
